export default __webpack_public_path__ + "static/media/chang_heum_yoon.5e8ef694.png";